import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";

import { MARGIN_CACHE_KEYS } from "./keys";

import { MarginRepository } from "@/repositories/margin";

export const useListMargins = () => {
  const marginRepository = useRef(new MarginRepository());

  return useQuery({
    queryKey: MARGIN_CACHE_KEYS.LIST,
    queryFn: async () => {
      return await marginRepository.current.findAll();
    },
    placeholderData: keepPreviousData,
  });
};
